export enum PaymentsIFrameModalMessages {
  closePaymentsIframe = "closePaymentsIframe",
  redirectToDashboard = "redirectToDashboard",
}
